import { Box, IconButton } from "@compass/core";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { Select } from "components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "redux/store";
import { getNavMenuItems, NavMenuItem } from "routes";

type SearchItem = { title: string; path: string };

const INITIAL_WIDTH: string = "0px";
const EXPANDED_WIDTH: string = "300px";

export const AppTopBarSearch = () => {
  const navigate = useNavigate();
  const appRoleId = useSelector((state: RootState) => state.app.roleId);
  const appReactMenus = useSelector((state: RootState) => state.app.reactMenus);
  const [navMenuItems, setNavMenuItems] = useState<NavMenuItem[] | undefined>();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState<boolean>(false);

  useEffect(() => {
    if (appRoleId && appReactMenus) {
      setNavMenuItems(getNavMenuItems(appReactMenus, appRoleId));
    }
  }, [appRoleId, appReactMenus]);

  let searchItems: SearchItem[] = [];

  if (navMenuItems) {
    for (let i = 0; i < navMenuItems.length; i++) {
      const menuItem = navMenuItems[i];

      for (let j = 0; j < menuItem.subMenuItems.length; j++) {
        const menuSubItem = menuItem.subMenuItems[j];

        if (!(menuSubItem.subSubMenuItems && menuSubItem.subSubMenuItems.length > 0))
          searchItems.push({ title: `${menuItem.title} > ${menuSubItem.title}`, path: menuSubItem.path! });
        else {
          for (let k = 0; menuSubItem.subSubMenuItems && k < menuSubItem.subSubMenuItems.length; k++) {
            const menuSubSubItem = menuSubItem.subSubMenuItems[k];

            searchItems.push({
              title: `${menuItem.title} > ${menuSubItem.title} > ${menuSubSubItem.title}`,
              path: menuSubSubItem.path,
            });
          }
        }
      }
    }
  }

  return (
    <>
      {!show && (
        <IconButton onClick={() => setShow(true)} size="large">
          <ManageSearchIcon />
        </IconButton>
      )}

      {show && (
        <Select
          autoFocus
          // inputSx={{ width: focused ? EXPANDED_WIDTH : INITIAL_WIDTH, transition: "width 300ms" }}
          inputSx={{ width: EXPANDED_WIDTH }}
          options={searchItems}
          getOptionLabel={(option) => option.title!}
          onChange={(e, value) => {
            navigate(value.path);
            setOpen(false);
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.length > 0) {
              setOpen(true);
            } else {
              setOpen(false);
            }
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => {
            setShow(false);
            setFocused(false);
          }}
          size="small"
          placeholder="Search menu"
          open={open}
          popupIcon={null}
        />
      )}
    </>
  );
};
